var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartnershipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.0072,
    cy: 40.0072,
    r: 40.0072,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.1972 42.6196H29.4407C28.0143 42.6196 26.6464 43.3422 25.6377 44.6286C24.6291 45.9149 24.0625 47.6596 24.0625 49.4788V52.9084",
    stroke: "#E60000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5856 37.2414C37.4913 37.2414 39.8469 34.8858 39.8469 31.9801C39.8469 29.0743 37.4913 26.7188 34.5856 26.7188C31.6798 26.7188 29.3242 29.0743 29.3242 31.9801C29.3242 34.8858 31.6798 37.2414 34.5856 37.2414Z",
    stroke: "#E60000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1106 52.9084V49.4788C56.1106 47.6596 55.544 45.9149 54.5354 44.6286C53.5267 43.3422 52.1588 42.6196 50.7324 42.6196H39.9759C38.5495 42.6196 37.1815 43.3422 36.1729 44.6286C35.1643 45.9149 34.5977 47.6596 34.5977 49.4788V52.9084",
    stroke: "#E60000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1207 37.2414C48.0265 37.2414 50.382 34.8858 50.382 31.9801C50.382 29.0743 48.0265 26.7188 45.1207 26.7188C42.215 26.7188 39.8594 29.0743 39.8594 31.9801C39.8594 34.8858 42.215 37.2414 45.1207 37.2414Z",
    stroke: "#E60000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnershipIcon);
export default __webpack_public_path__ + "static/media/partnership-icon.90713a21b3ee699abb47a0e9260f9716.svg";
export { ForwardRef as ReactComponent };